import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './store';
import Auth        from './pages/Auth';
import Lobby       from './pages/Lobby';
import Game        from './pages/Game';
import Leaderboard from './pages/Leaderboard';
import Agent       from './pages/Agent';
import Ledger      from './pages/Ledger';
import Invite      from './pages/Invite';
import Withdraw    from './pages/Withdraw';
import CardSale    from './pages/CardSale';
import BuyCard     from './pages/BuyCard';
import Tasks       from './pages/Tasks';
import Admin       from './pages/Admin';
import FriendLobby from './pages/FriendLobby';
import FriendGame  from './pages/FriendGame';
import Redpack     from './pages/Redpack';

function Guard({ children }) {
  const { user, loading } = useApp();
  if (loading) return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'var(--bg)', fontFamily:'Oswald', fontSize:24, color:'var(--muted)',
      letterSpacing:4,
    }}>
      LOADING...
    </div>
  );
  return user ? children : <Navigate to="/" replace />;
}

function AppRoutes() {
  const { user } = useApp();
  return (
    <Routes>
      <Route path="/"            element={user ? <Navigate to="/lobby" replace /> : <Auth />} />
      <Route path="/lobby"       element={<Guard><Lobby /></Guard>} />
      <Route path="/game/:level" element={<Guard><Game /></Guard>} />
      <Route path="/leaderboard" element={<Guard><Leaderboard /></Guard>} />
      <Route path="/agent"       element={<Guard><Agent /></Guard>} />
      <Route path="/ledger"      element={<Guard><Ledger /></Guard>} />
      <Route path="/invite"      element={<Guard><Invite /></Guard>} />
      <Route path="/withdraw"    element={<Guard><Withdraw /></Guard>} />
      <Route path="/card-sale"   element={<Guard><CardSale /></Guard>} />
      <Route path="/tasks"       element={<Guard><Tasks /></Guard>} />
      <Route path="/admin"       element={<Guard><Admin /></Guard>} />
      <Route path="/buy/:code"   element={<BuyCard />} />
      <Route path="/register"    element={<Auth />} />
      <Route path="/friend"      element={<Guard><FriendLobby /></Guard>} />
      <Route path="/friend/:code"  element={<FriendGame />} />
      <Route path="/redpack/:code" element={<Redpack />} />
      <Route path="*"             element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}
